import React, { useState, useEffect, useRef } from 'react';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { updateDoc, doc } from 'firebase/firestore';
import { useFirestoreDoc } from '../../../hooks/useFirestoreDoc';
import { storage, db, firestore } from '../../../firebase/firebase';
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import styles from './DebatesTab.module.css';
import { HiClock, HiUserGroup, HiUsers, HiUserPlus, HiMagnifyingGlass } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';
import DebateCard from './../DebateCard/DebateCard';
import FriendRequests from './../FriendRequests/FriendRequests';
import FriendsList from './../FriendsList/FriendsList';
import FollowersList from './../FollowersList/FollowersList';
import FollowingList from './../FollowingList/FollowingList';
import { useSortCollection } from '../../../hooks/useSortCollection';
import useScrollToId from '../../../hooks/useScrollToId';
import { useAuth } from "../../../utils/AuthContext/authcontext";
import UserSearch from '../../../utils/UserSearch/UserSearch';
//import { acceptFriendRequest, declineFriendRequest, removeFriend, unfollowUser, followUser, addFriend } from "../../../utils/friendService/friendService";
import  { joinDebate, leaveDebate, withdrawDebate } from "../../../utils/debateService/debateService";

import RelationshipGridLayout from './../../layout/RelationshipGridLayout';
import RelationshipMasonryLayout from './../../layout/RelationshipMasonryLayout';
import RelationshipOrganicLayout from './../../layout/RelationshipOrganicLayout';
import MasonryLayout from './../../layout/MasonryLayout';
import CompactProfile from './../../CompactProfile/CompactProfile';
import PopoverCard from './../../PopoverCard/PopoverCard';

/*const sections = [
  {
    id: 'friends',
    title: 'FriendsList',
    icon: HiUserGroup,
    content: <FriendsList friends={friendData} onRemove={(id) => removeFriendRequest(id)} isLoading={loading}  onFindFriends={handleFind}/>,
  },
  {
    id: 'requests',
    title: 'Friend Requests',
    icon: HiUserPlus,
    content:  <FollowersList followers={followersData} />,
  },
  {
    id: 'followers',
    title: 'Followers',
    icon: HiUsers,
    content:  <FollowingList following={followingData} onUnfollow={(id) => handleUnfollow(id)}/>,
  },
  {
    id: 'usersearch',
    title: 'Search Users',
    icon: HiMagnifyingGlass,
    content: <UserSearch userId={user?.uid}/>,
  },
];*/

export default function DebatesTab({ user }) {
  const { docs: upcoming, loading: loadingUpcoming } = useSortCollection(`users/${user?.uid}/debates`, [['status', '==', 'upcoming']]);
  const { docs: live, loading: loadingLive } = useSortCollection(`users/${user?.uid}/debates`, [['status', '==', 'live']]);
  const { docs: past, loading: loadingPast } = useSortCollection(`users/${user?.uid}/debates`, [['status', '==', 'past']]);

  /*const { docs: requests } = useSortCollection(`users/${user?.uid}/friendRequests`);
  const { docs: friends } = useSortCollection(`users/${user?.uid}/friends`);
  const { docs: followers } = useSortCollection(`users/${user?.uid}/followers`);
  const { docs: following } = useSortCollection(`users/${user?.uid}/following`);*/
  const scrollToId = useScrollToId(120); // Adjust if you have sticky header
  const { userData, isFollowing, declineFriendRequest, handleUnfollow, handleFollow, searchbyUsersId, acceptFriendRequest, removeFriendRequest, sendFriendRequest, searchUsers } = useAuth();
  const { t } = useTranslation();
  const { notify } = useNotifications();
  const [friendrequestData, setfriendrequestData] = useState(null);
  const [friendData, setfriendData] = useState(null);
  
  const [friendloading, setfriendloading] = useState(true);
  const [followloading, setfollowloading] = useState(true);
  const [followerloading, setfollowerloading] = useState(true);
  const [requestloading, setrequestloading] = useState(true);
  
  const [followingData, setfollowingData] = useState(null);
  const [followersData, setfollowersData] = useState(null);
  const [showprofile, setShowProfile] = useState(null);
  const [anchorRect, setAnchorRect] = useState(null);
 
  const handleFind = () => scrollToId('usersearch');
  
  const openUserProfile = (user, event) => {
	const rect = event.currentTarget.getBoundingClientRect();
	setAnchorRect(rect);
	setShowProfile(user);
	scrollToId('userprofile');
  };
  
   useEffect(() => {
    var user = [];
	setfollowloading(true);
	if (userData?.following?.length > 0) {
      const fetchUserData = async () => {
		let data = await Promise.all(userData.following.map(async (requestId) => {
			var user = [];
			if(requestId?.length > 0) {
				const users = await searchbyUsersId(requestId);
				for (const doc of users) {
					user.push({uid: doc.uid, username: doc.username, profilePicture: doc.profilePicture});
				}
				return user;
			}
			else {
				return [];
			}
		}))
		for (const doc of data) {
			for (const item of doc) {
				user.push(item);
			}
		}
		setfollowingData(user);
		setfollowloading(false);
      };
      fetchUserData();
    } else {
		setfollowingData(user);
		setfollowloading(false);
	}
  }, [userData, userData?.following]);

   useEffect(() => {
    var user = [];
	setrequestloading(true);
	if (userData?.friendRequests?.length > 0) {
      const fetchUserData = async () => {
		let data = await Promise.all(userData.friendRequests.map(async (requestId) => {
			var user = [];
			if(requestId?.length > 0) {
				const users = await searchbyUsersId(requestId);
				for (const doc of users) {
					user.push({uid: doc.uid, username: doc.username, profilePicture: doc.profilePicture});
				}
				return user;
			}
			else {
				return [];
			}
		}))
		for (const doc of data) {
			for (const item of doc) {
				user.push(item);
			}
		}
		setfriendrequestData(user);
		setrequestloading(false);
      };
      fetchUserData();
    } else {
		setfriendrequestData(user);
		setrequestloading(false);
	}
  }, [userData, userData?.friendRequests]);

  useEffect(() => {
    var user = [];
	setfollowerloading(true);
	if (userData?.followers?.length > 0) {
      const fetchUserData = async () => {
		let data = await Promise.all(userData.followers.map(async (requestId) => {
			var user = [];
			if(requestId?.length > 0) {
				const users = await searchbyUsersId(requestId);
				for (const doc of users) {
					user.push({uid: doc.uid, username: doc.username, profilePicture: doc.profilePicture});
				}
				return user;
			}
			else {
				return [];
			}
		}))
		for (const doc of data) {
			for (const item of doc) {
				user.push(item);
			}
		}
		setfollowersData(user);
		setfollowerloading(false);
      };
      fetchUserData();
    } else {
		setfollowersData(user);
		setfollowerloading(false);
	}
  }, [userData, userData?.followers]);
  

  useEffect(() => {
    var user = [];
	setfriendloading(true);
	if (userData?.friends?.length > 0) {
      const fetchUserData = async () => {
		let data = await Promise.all(userData.friends.map(async (requestId) => {
			var user = [];
			if(requestId?.length > 0) {
				const users = await searchbyUsersId(requestId);
				for (const doc of users) {
					user.push({status: doc.status, uid: doc.uid, username: doc.username, profilePicture: doc.profilePicture});
				}
				return user;
			}
			else {
				return [];
			}
		}))
		for (const doc of data) {
			for (const item of doc) {
				user.push(item);
			}
		}
		setfriendData(user);
		setfriendloading(false);
      };

      fetchUserData();
	  
    } else {
		setfriendData(user);
		setfriendloading(false);
	}
  }, [userData, userData?.friends]);
  
	const sections = [
	   {
		id: 'usersearch',
		content: <UserSearch userId={user?.uid}/>,
	  },
	  {
		id: 'userprofile',
		content: <>
			{showprofile && anchorRect && (
			  <CompactProfile isTile={true} userId={showprofile} onCloseWindow={() => setShowProfile(null)} />
			)}</>
	  },
	  {
		id: 'friends',
		content: <FriendsList friends={friendData} onView={openUserProfile} onRemove={(id) => removeFriendRequest(id)} isLoading={friendloading}  onFindFriends={handleFind}/>,
	  },
	  {
		id: 'requests',
		content:  <FriendRequests onView={openUserProfile}  isLoading={requestloading} requests={friendrequestData} onAccept={async (id) => {
				try {
				  await acceptFriendRequest(id);
				  notify('success', 'Friend request accepted!');
				} catch (err) {
				  notify('error', 'Something went wrong');
				}
				
			}} onDecline={(id) => declineFriendRequest(id)}/>,
	  },
	  {
		id: 'following',
		content:  <FollowingList onView={openUserProfile}  isLoading={followloading} following={followingData} onUnfollow={(id) => handleUnfollow(id)}/>,
	  },
	  {
		id: 'followers',
		content: <FollowersList onView={openUserProfile}  isLoading={followerloading} followers={followersData} />,
	  },
	  {
		id: 'upcoming',
		content: <Section title={t('debates.upcoming')} icon={<HiClock />}>
			{loadingUpcoming ? <Loading /> : upcoming.length === 0 ? <Empty /> : upcoming.map(d => <DebateCard key={d.id} data={d} />)}
		  </Section>,
	  },
	  {
		id: 'live',
		content: <Section title={t('debates.live')} icon={<HiUserGroup />}>
			{loadingLive ? <Loading /> : live.length === 0 ? <Empty /> : live.map(d => <DebateCard key={d.id} data={d} />)}
		  </Section>,
	  },
	  {
		id: 'past',
		content: <Section title={t('debates.past')} icon={<HiUsers />}>
			{loadingPast ? <Loading /> : past.length === 0 ? <Empty /> : past.map(d => <DebateCard key={d.id} data={d} />)}
		  </Section>,
	  },
	];

  return (
	<div className={styles.wrapper}>
	<div className={styles.background}></div>
    <div className={styles.cardd}>
      <h3 className={styles.heading}>{t('debates.title')}</h3>
      <p className={styles.summary}>{t('debates.summary')}</p>
	  <RelationshipMasonryLayout sections={sections} />
    </div>
    </div>
  );
}

function Section({ title, icon, children }) {
  return (
    <div className={styles.section}>
      <h4 className={styles.sectionTitle}>{icon} {title}</h4>
      <div>{children}</div>
    </div>
  );
}

function Empty() {
    const { t } = useTranslation();
  return <div className={styles.empty}>{t('debates.noDebates')}</div>;
}

function Loading() {
    const { t } = useTranslation();
  return <div className={styles.empty}>{t('debates.loading')}</div>;
}
